export const GET_CRYPTO_CURRENCIES = 'GET_CRYPTO_CURRENCIES'
export const GET_FIAT_CURRENCIES = 'GET_FIAT_CURRENCIES'
export const GET_RATE = 'GET_RATE'
